import { Route, Redirect, RouteProps } from 'react-router-dom'
import { useAuth } from 'providers/auth'
import { LoadingScreen } from 'components/Loading'

export type PrivateRouteProps = RouteProps & {
  component: any
  checkAccess?: () => string | null
}

export function PrivateRoute({
  component: Component,
  checkAccess,
  ...rest
}: PrivateRouteProps) {
  const { loading, user } = useAuth()
  return (
    <Route
      {...rest}
      render={({ location, ...props }) => {
        if (loading) {
          return <LoadingScreen />
        } else if (user) {
          const redirectPath = checkAccess && checkAccess()
          if (redirectPath) {
            return (
              <Redirect
                to={{
                  pathname: redirectPath,
                  state: { from: location },
                }}
              />
            )
          }
          return <Component {...props} />
        } else {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: location },
              }}
            />
          )
        }
      }}
    />
  )
}
